import { Action } from '@ngrx/store';
import { Budget, BudgetRequest } from '@model';

export enum BudgetsActionTypes {
  BudgetLoadData = '[Budgets] Load budget',
  BudgetLoadDataSuccess = '[Budgets] Load budget success',
  BudgetLoadDataFail = '[Budgets] Load budget fail',

  BudgetSetSelected = '[Budgets] Set loaded budget as selected',
/*
  BaseBudgetLoadData = '[Budgets] Load base budget',
  BaseBudgetLoadDataSuccess = '[Budgets] Load base budget success',
  BaseBudgetLoadDataFail = '[Budgets] Load base budget fail',

  BaseBudgetSetSelected = '[Budgets] Set loaded base budget as selected',
*/
  PrognosisLoadData = '[Prognosis] Load prognosis',
  PrognosisLoadDataSuccess = '[Prognosis] Load prognosis success',
  PrognosisLoadDataFail = '[Prognosis] Load prognosis fail',

  SelectPriceListCode = '[Budget] Select PriceListCode',
  ClearPrognosisData = '[Budget] Clear prognosis data',

  SelectTabIndexPrognosis = '[Prognosis] Select Tabindex for prognosis',
}

// Budget
export class BudgetLoad implements Action {
  readonly type = BudgetsActionTypes.BudgetLoadData;
  constructor(public payload: BudgetRequest) {}
}
export class BudgetLoadSuccess implements Action {
  readonly type = BudgetsActionTypes.BudgetLoadDataSuccess;
  constructor(public payload: Budget) {}
}
export class BudgetLoadFail implements Action {
  readonly type = BudgetsActionTypes.BudgetLoadDataFail;
  constructor(public payload: any) {}
}

export class BudgetSetLoadedAsSelected implements Action {
  readonly type = BudgetsActionTypes.BudgetSetSelected;
  constructor(public payload: number) {}
}

// Prognosis
export class PrognosisLoad implements Action {
  readonly type = BudgetsActionTypes.PrognosisLoadData;
  constructor(public payload: BudgetRequest) {}
}
export class PrognosisLoadSuccess implements Action {
  readonly type = BudgetsActionTypes.PrognosisLoadDataSuccess;
  constructor(public payload: Budget) {}
}
export class PrognosisLoadFail implements Action {
  readonly type = BudgetsActionTypes.PrognosisLoadDataFail;
  constructor(public payload: any) {}
}
export class SelectPriceListCode implements Action {
  readonly type = BudgetsActionTypes.SelectPriceListCode;
  constructor(public payload: string) {}
}
export class ClearPrognosisData implements Action {
  readonly type = BudgetsActionTypes.ClearPrognosisData;
  constructor() {}
}

export class SelectTabIndexPrognosis implements Action{
  readonly type = BudgetsActionTypes.SelectTabIndexPrognosis;
  constructor(public payload: number){}
}

export type BudgetsActions =
  | BudgetLoad
  | BudgetLoadSuccess
  | BudgetLoadFail
  | BudgetSetLoadedAsSelected
  | PrognosisLoad
  | PrognosisLoadSuccess
  | PrognosisLoadFail
  | SelectPriceListCode
  | ClearPrognosisData
  | SelectTabIndexPrognosis;
